module.exports = global["jQuery"] = require("-!/Users/tshawver/repo/qgrid/js/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = 1
// module chunks = 0